export default __webpack_public_path__ + "static/media/vector-art-welcome.31d80f71.svg";